import type { UserRole } from '../../stores/auth-store';

const ANALYTICS_WRITE_ROLES = new Set<UserRole>(['OWNER', 'ADMIN', 'MARKETER']);

export function canCustomizeAnalytics(role: UserRole): boolean {
  return ANALYTICS_WRITE_ROLES.has(role);
}
